module.exports = __webpack_public_path__ + "img/elementheights_jasa.46317524.png";